module.exports = __webpack_public_path__ + "static/media/explain_img.588a439d.png";